import $ from "/srv/www/h/hoekstraenpartners.nl/vhosts/sintnicolaasga/htdocs/content/mu-plugins/wp-soup-plugin/node_modules/jquery";

$(document).ready(function() {
    //
});
